import { type FC } from 'react';
import { motion } from 'framer-motion';

import { Picture } from '@/components/ui/Picture/Picture';
import { useAppSelector } from '@/redux/store';

import css from '../styles.module.scss';

import lightPng from '/img/blurred-light.png';
import levelUpAvatar from '/img/modals/level-up-avatar.svg';

const LevelUpCharacter: FC<{
  upgrade: number;
  className?: string;
  isClaimed?: boolean;
}> = ({ upgrade, className, isClaimed = false }) => {
  const photoUrl = useAppSelector((state) => state.user.user?.photoUrl);

  return (
    <motion.div
      className={`relative w-72 z-0 ${className}`}
      layoutId="level-up-character"
      animate={isClaimed ? { scale: 1.8 } : { scale: 1 }}
      transition={{ duration: 0.3 }}
    >
      <div className="absolute flex items-center justify-center top-[calc(50%-1rem)] left-1/2 -translate-y-1/2 -translate-x-1/2 z-[-1] pointer-events-none">
        <div className="bg-accent-sec h-32 w-[13rem] rounded-full blur-[32px] absolute" />
        <div className="bg-accent-sec h-[10rem] w-[17rem] rounded-full blur-[100px] absolute" />
        <Picture
          className={css.lightAnimate}
          img={lightPng}
          alt="Level up light"
        />
      </div>
      <img src={levelUpAvatar} alt={'Level up avatar'} className="w-full" />
      <img
        src={photoUrl || ''}
        alt="User Avatar"
        className="absolute size-[6.625rem] top-[3.125rem] rounded-full left-1/2 -translate-x-1/2"
      />
      <span className="text-[2.5rem] font-extrabold absolute left-1/2 -translate-x-1/2 bottom-[13.75%] leading-none">
        {upgrade}
      </span>
    </motion.div>
  );
};

export default LevelUpCharacter;
